import { render, staticRenderFns } from "./AdminPendingActions.vue?vue&type=template&id=3cffeac3&scoped=true&"
import script from "./AdminPendingActions.vue?vue&type=script&lang=js&"
export * from "./AdminPendingActions.vue?vue&type=script&lang=js&"
import style0 from "./AdminPendingActions.vue?vue&type=style&index=0&id=3cffeac3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cffeac3",
  null
  
)

export default component.exports